export const customColorSwatchImage = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <rect fill="#B4E1E9" x="0" y="0" width="9" height="9"></rect>
    <rect fill="#CAE0AB" x="8" y="0" width="9" height="9"></rect>
    <rect fill="#FBE89B" x="16" y="0" width="9" height="9"></rect>
    <rect fill="#FAC2C1" x="24" y="0" width="9" height="9"></rect>
    <rect fill="#E2E5F1" x="32" y="0" width="8" height="9"></rect>
    <rect fill="#89CBD4" x="0" y="8" width="9" height="9"></rect>
    <rect fill="#B8D12C" x="8" y="8" width="9" height="9"></rect>
    <rect fill="#EFDD30" x="16" y="8" width="9" height="9"></rect>
    <rect fill="#F63680" x="24" y="8" width="9" height="9"></rect>
    <rect fill="#B8B1BD" x="32" y="8" width="8" height="9"></rect>
    <rect fill="#A4C5E3" x="0" y="16" width="9" height="9"></rect>
    <rect fill="#6B9036" x="8" y="16" width="9" height="9"></rect>
    <rect fill="#D7C329" x="16" y="16" width="9" height="9"></rect>
    <rect fill="#F46866" x="24" y="16" width="9" height="9"></rect>
    <rect fill="#89779F" x="32" y="16" width="8" height="9"></rect>
    <rect fill="#3080C5" x="0" y="24" width="9" height="9"></rect>
    <rect fill="#5D6323" x="8" y="24" width="9" height="9"></rect>
    <rect fill="#F29F21" x="16" y="24" width="9" height="9"></rect>
    <rect fill="#CC2427" x="24" y="24" width="9" height="9"></rect>
    <rect fill="#6C246A" x="32" y="24" width="8" height="9"></rect>
    <rect fill="#192D59" x="0" y="32" width="9" height="8"></rect>
    <rect fill="#4C753F" x="8" y="32" width="9" height="8"></rect>
    <rect fill="#F66D15" x="16" y="32" width="9" height="8"></rect>
    <rect fill="#A21732" x="24" y="32" width="9" height="8"></rect>
    <rect fill="#3A1D59" x="32" y="32" width="8" height="8"></rect>
</svg>
`;
